const KITS = {
  "Crumb King": { weapon: "dinner_fork", moves: ["dash", "swing", "slam"], rain: "crumbdrop", wave: "#B45309", swingLabel: "ROYAL FORK SWING!", rainLabel: "CRUMB STORM!" },
  "Jam Kraken": { weapon: "rolling_pin", moves: ["pillars", "swing", "slam"], pillar: "jam", wave: "#7E22CE", swingLabel: "ROLLING PIN SMASH!", pillarLabel: "JAM GEYSERS!" },
  "Mold Titan": { weapon: "whisk_flail", moves: ["rain", "swing", "pillars", "slam"], rain: "spore", pillar: "vine", wave: "#047857", swingLabel: "WHISK FLAIL!", rainLabel: "SPORE RAIN!", pillarLabel: "VINE TRAP!" },
  "Burnt Baron": { weapon: "chef_cleaver", moves: ["dash", "rain", "swing"], rain: "ember", swingLabel: "CLEAVER SLASH!", rainLabel: "EMBER RAIN!" },
  "Toaster Overlord": { weapon: "golden_spatula", moves: ["swing", "rain"], rain: "ember", swingLabel: "SPATULA SWAT!", rainLabel: "HOT CRUMB RAIN!" },
};

export const kitFor = (name) => KITS[name.replace(/ (II|III|IV)$/, "")];

// bosses are a bit tougher everywhere, only slightly on Toast Master, and the Toaster Overlord stays as before
export const bossPower = (diffKey, overlord) => {
  if (overlord) return { hp: 1, speed: 1, atk: 0.85 };
  if (diffKey === "master") return { hp: 1.06, speed: 1.04, atk: 1.04 };
  return { hp: 1.25, speed: 1.15, atk: 1.2 };
};

export const moveLabel = (kind, kit) => ({ dash: "CHARGE!", slam: "GROUND SLAM!", swing: kit.swingLabel, rain: kit.rainLabel, pillars: kit.pillarLabel }[kind]);

export const moveCooldown = (b, diffKey) => ((b.enraged ? 2.3 : 3.3) / b.pw.atk) * (diffKey === "easy" ? 1.6 : 1);

// weapon angle relative to the boss facing direction (base) for each move stage
export const weaponAngle = (b, base, f) => {
  const m = b.move;
  if (!m) return base - f * 1.0;
  if (m.kind === "dash" && m.stage === 1) return base;
  if (m.kind !== "swing") return base - f * 1.0;
  if (m.stage === 1) return base - f * (1.0 + Math.min(1, m.t / 0.45) * 1.2);
  if (m.stage === 2) return base - f * 2.2 + f * 3.4 * Math.min(1, m.t / 0.25);
  if (m.stage === 3) return base + f * 1.2;
  return base - f * 1.0;
};

export const isWindup = (b) => b.move && ((b.move.kind === "dash" && b.move.stage === 0) || (b.move.kind === "slam" && b.move.stage === 0) || (b.move.kind === "swing" && b.move.stage === 1));
